/* eslint-env browser */
import React, { PureComponent } from 'react';
import { first, last, throttle } from 'lodash/fp';
import { EVENTS } from 'constants/config';

const LIST_SELECTOR = '.PathContentsList';
const STEP_NUMBER_SELECTOR = '.PathContentStep, .PathContentCollapsed-step';
const COLLAPSED_STEP_CLASS_NAME = 'PathContentStep--collapsed';
const COLLAPSED_COMPLETED_STEP_CLASS_NAME = 'PathContentCollapsed-step';
const INNER_COMPLETED_STEP_CLASS_NAME = 'PathContentStep-innerStep';
const TIMEOUT_DELAY = 50;

function getAbsolutePosition(elem) {
  const rect = elem.getBoundingClientRect();
  const { body } = document;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  return {
    top: rect.top + scrollTop - clientTop,
    height: rect.height,
  };
}

const getPreviousFullStep = (steps, index) => {
  if (!index) {
    return null;
  }
  const previous = steps[index - 1];
  if (
    previous.className.includes(COLLAPSED_COMPLETED_STEP_CLASS_NAME) ||
    previous.className.includes(INNER_COMPLETED_STEP_CLASS_NAME)
  ) {
    /*
     * Skip inner collapsed steps
     */
    return getPreviousFullStep(steps, index - 1);
  }
  return previous;
};

class StepsConnector extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { top: 0, completedConnectors: [] };
    this.setPosition = throttle(100)(this.setPosition.bind(this));
    this.timerId = null;
  }

  setPosition() {
    clearTimeout(this.timerId);
    this.timerId = setTimeout(() => {
      const steps = document.querySelectorAll(STEP_NUMBER_SELECTOR);
      const list = document.querySelector(LIST_SELECTOR);
      if (steps.length <= 1) {
        this.setState({ top: 0, bottom: null });
      } else if (steps.length > 1) {
        if (this.props.showDashes) {
          for (let i = 1; i < steps.length; i += 1) {
            const previous = getPreviousFullStep(steps, i);
            const current = steps[i];
            if (previous.className.includes(COLLAPSED_STEP_CLASS_NAME)) {
              const previousRect = getAbsolutePosition(previous);
              const currentRect = getAbsolutePosition(current);
              const top =
                previousRect.top + previousRect.height - list.offsetTop;
              const height =
                currentRect.top - previousRect.top - previousRect.height;
              const key = previous.id;
              this.setState(({ completedConnectors }) => ({
                completedConnectors: {
                  ...completedConnectors,
                  [key]: {
                    key,
                    top,
                    height,
                  },
                },
              }));
            }
          }
        }
        const firstStepRect = getAbsolutePosition(first(steps));
        const lastStepRect = getAbsolutePosition(last(steps));
        const listRect = getAbsolutePosition(list);
        this.setState({
          top: firstStepRect.top + firstStepRect.height - list.offsetTop - 1,
          bottom: listRect.height - lastStepRect.top + listRect.top - 1,
        });
      }
    }, TIMEOUT_DELAY);
  }

  componentDidMount() {
    window.addEventListener('resize', this.setPosition);
    global.pubsub.subscribe(
      EVENTS.SET_STEP_CONNECTOR_POSITION,
      this.setPosition,
    );
    this.setPosition();
  }

  componentWillUnmount() {
    global.pubsub.unsubscribe(
      EVENTS.SET_STEP_CONNECTOR_POSITION,
      this.setPosition,
    );
    window.removeEventListener('resize', this.setPosition);
  }

  render() {
    const { top, bottom, completedConnectors } = this.state;
    return (
      <>
        {Object.values(completedConnectors).map(connector => (
          <div
            key={connector.key}
            className="StepsConnector StepsConnector--dashed"
            style={{ top: connector.top, height: connector.height }}
          />
        ))}
        <div className="StepsConnector" style={{ top, bottom }} />
      </>
    );
  }
}

export default StepsConnector;
